import { erpApi } from "@/shared/axios";
import { urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { IKitInventario, IKitInventarioParams, IKitResponseData, KitInventariableForm } from "@/shared/interfaces/erp/inventario/kit-inventario.interface";
import { getUrlParamsFetch } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

const { post, get, put } = erpApi();

///* Obtener todos los kit

export const fetchGetKitInventario = (
  params: IKitInventarioParams,
) => {
  return useQuery({
    queryKey: ['kit-inventario', ...Object.values(params || {})],
    queryFn: async () => {
      return await getKitInventario(params)
    },
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export const getKitInventario = async (params: IKitInventarioParams) => {
  const queryParams = getUrlParamsFetch(params || {})
  return await get<IKitResponseData>(`${urlBackend}api/v1/kitinventario/?${queryParams}`, true)
}

///* Obtener kit por id
export const fetchGetKitInventarioById = (id: string) => {
  return useQuery({
    queryKey: ['kit-inventario', id],
    queryFn: async () => {
      return await getKitInventarioById(id)
    },
    retry: false,
    refetchOnWindowFocus: false,
  })
}

export const getKitInventarioById = async (id: string) => {
  return await get<IKitInventario>(`${urlBackend}api/v1/kitinventario/${id}`, true)
}


///* Crear un kit
export const fetchPostCreateKitInventario = ({
  enableSuccessAlert = true

}: UseMutationsParams = {}) => {

  const setAlert = useUiStore.getState().setAlert

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: KitInventariableForm) => {
      return postCreateKitInventario(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['kit-inventario'] });

      enableSuccessAlert &&
        setAlert(true, data.message, AlertSeverityEnum.success)
    },
    onSettled: () => {

    }
  })
}

export const postCreateKitInventario = async (data: KitInventariableForm) => {
  return await post<IKitInventario>(`${urlBackend}api/v1/kitinventario/`, data, true)
}

///* Editar un kit inventario

interface IEditKitInventario {
  id: string
  data: KitInventariableForm
}
export const fetchPutEditKitInventario = ({
  enableSuccessAlert = true,
  navigate,
  redirect,
  returnUrl

}: UseMutationsParams = {}) => {

  const setAlert = useUiStore.getState().setAlert

  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: IEditKitInventario) => {
      return putEditInventario(data);
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['kit-inventario'] });

      enableSuccessAlert &&
        setAlert(true, data.message, AlertSeverityEnum.success)

      redirect && navigate && returnUrl &&
        navigate(returnUrl)
    },
    onSettled: () => {

    }
  })
}


export const putEditInventario = async (data: IEditKitInventario) => {
  return await put<IKitInventario>(`${urlBackend}api/v1/kitinventario/${data.id}/`, data.data, true)
}